import React from 'react';

const faqs = [
  {
    question: "What makes a good bar name?",
    answer: "A good bar name should be memorable, reflect your establishment's style and atmosphere, and resonate with your target customers. Consider incorporating local elements, your bar's theme, or unique characteristics."
  },
  {
    question: "How do you create a unique bar name?",
    answer: "To create a unique bar name, combine elements like your location, concept, and distinctive features. Our generator helps by combining these elements with bar-specific terms and popular naming patterns."
  },
  {
    question: "What are popular themes for bar names?",
    answer: "Popular themes include traditional pub names (The King's Arms), sophisticated lounge names (The Velvet Room), sports-themed names (Champions Bar & Grill), and speakeasy names (The Hidden Parlor)."
  },
  {
    question: "Should my bar name be serious or creative?",
    answer: "This depends on your bar's concept and target audience. Traditional pubs often choose more classic names, while modern bars might opt for more creative or trendy names. Consider your atmosphere and clientele."
  },
  {
    question: "Can I use my generated bar name commercially?",
    answer: "Yes, the names generated are free to use. However, we recommend checking for existing trademarks and business names in your area before finalizing your choice."
  },
  {
    question: "How often are new names added to the generator?",
    answer: "Our AI system continuously learns from current trends and user preferences to expand its name generation capabilities, ensuring fresh and relevant suggestions."
  }
];

export default function BarFAQ() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
          Bar Names FAQ
        </h2>
        
        <div className="space-y-8">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-amber-50 p-6 rounded-lg">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                {faq.question}
              </h3>
              <p className="text-gray-600">{faq.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}